import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    meetingExternalId: null,
    legacySessionRequestState: 'not-started',
};
export const joinInterviewSlice = createSlice({
    name: 'joinInterview',
    initialState,
    reducers: {
        updateMeetingParticipationStatusRequest(_state, _action) {
            // Trigger for saga worker
        },
        // New action to trigger step details processing for JoinInterview
        processStepDetailsRequest(_state, _action) {
            // Trigger for saga worker - no state changes needed as data is stored in App slice
        },
        // New action to trigger legacy live session fetch
        fetchLegacyLiveSessionRequest(state, _action) {
            state.legacySessionRequestState = 'loading';
        },
        // Action to set legacy session fetched status
        storeMeetingExternalId: (state, action) => {
            state.meetingExternalId = action.payload;
            state.legacySessionRequestState = 'loaded';
        },
    },
});
export const { updateMeetingParticipationStatusRequest, processStepDetailsRequest, fetchLegacyLiveSessionRequest, storeMeetingExternalId, } = joinInterviewSlice.actions;
export default joinInterviewSlice.reducer;
